import { ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BarChart3, Bot, FileText, MessageCircle, Megaphone, Phone, ShieldCheck, ShoppingBag } from 'lucide-react';
import clsx from 'clsx';
import { Topbar } from '@/components/Topbar';

export type WhatsAppSection = 'overview' | 'chats' | 'templates' | 'campaigns' | 'automation' | 'catalog' | 'ads' | 'accounts' | 'tools';
const sections = [
  { key: 'overview', label: 'Overview', to: '/whatsapp', icon: BarChart3 },
  { key: 'chats', label: 'Inbox', to: '/chats', icon: MessageCircle },
  { key: 'templates', label: 'Templates', to: '/templates', icon: FileText },
  { key: 'campaigns', label: 'Campaigns', to: '/campaigns', icon: Megaphone },
  { key: 'automation', label: 'Automation', to: '/leads/bot-flows', icon: Bot },
  { key: 'catalog', label: 'Catalog & tools', to: '/whatsapp/catalog', icon: ShoppingBag },
  { key: 'ads', label: 'Status ads', to: '/whatsapp/ads', icon: Megaphone },
  { key: 'accounts', label: 'Accounts', to: '/whatsapp-accounts', icon: Phone },
  { key: 'tools', label: 'Health & safety', to: '/whatsapp-account/tools', icon: ShieldCheck },
] as const;

export function WhatsAppNav({ section }: { section?: WhatsAppSection }) {
  const { pathname } = useLocation();
  const selected = section ?? (pathname.startsWith('/whatsapp-account/bulk') ? 'campaigns' : sections.find(s => s.to === '/whatsapp' ? pathname === s.to : pathname.startsWith(s.to))?.key);
  return <nav aria-label="WhatsApp workspace" className="flex shrink-0 items-center gap-1 overflow-x-auto border-b border-border bg-surface px-4 sm:px-7">
    {sections.map(({ key, label, to, icon: Icon }) => <Link key={key} to={to} aria-current={selected === key ? 'page' : undefined}
      className={clsx('flex shrink-0 items-center gap-2 whitespace-nowrap border-b-2 px-3 py-3.5 text-[13px] font-medium transition-colors', selected === key ? 'border-primary text-primary' : 'border-transparent text-text-muted hover:text-text-primary')}>
      <Icon size={16} />{label}
    </Link>)}
  </nav>;
}

export function WhatsAppHeader({ title, description, actions, section, back, breadcrumb }: { title: string; description?: string; actions?: ReactNode; section?: WhatsAppSection; back?: ReactNode; breadcrumb?: string }) {
  return <><Topbar title={title} breadcrumb={breadcrumb ?? `WhatsApp / ${title}`} description={description} right={actions} autoBack={false}
    back={back ?? <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-gold-gradient text-on-primary"><MessageCircle size={24} strokeWidth={1.8} /></div>} /><WhatsAppNav section={section} /></>;
}
